var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"free-time-box"},[_c('p',{staticClass:"free-box",style:(_vm.styles)},[_c('img',{attrs:{"src":require("@/assets/img/count-down.svg"),"width":"13"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('限时免费')))])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d953e04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/freeTime/index.vue
// module id = null
// module chunks = 